/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
// import { useRouter } from 'next/router';
import HomeTopSlider from '../../components/home/slider/HomeTopSlider';
// import RemoteConfigContext from '../../contexts/remoteConfig';
import { getOrganizationPropertiesByHost } from '../../utils/helpers';
// import CourseData from '../../components/home/course-section/CourseData';
// import LayoutComponent from '../../components/home/layouts/LayoutComponent';

// import DailyMcqs from '../../components/home/daily-mcqs/DailyMcqs';
// import { GET_HOME_VIDEOS_PDF_MCQS_BY_TYPE } from '../../components/shared/HomeQueryList';
// import { GET_COURSES_BY_TAGS } from '../../components/shared/QueryList';
import GET_COURSES_BY_TAGS from '../../gql/queries/get-courses-by-tags.gql';
import { useUser } from '../../contexts/ssr-user-context';
import OfflineCourses from '../../components/home/course-section/OfflineCourses';
import OnlineCourses from '../../components/home/course-section/OnlineCourses';
import MetaHead from '../../components/metaHead';
import { getMetadata } from '../../utils/metaDataTitle';
import QuickLinksList from '../../components/home/quick-links/QuickLinksList';
import SlotBooking from '../../components/home/slot-booking/SlotBooking';
import TestSeriesCard from '../../components/test-series/mock-test/mocktest-listing/test-series-card';
import CourseTags from '../../components/course-list/courseTags';
import ViewAllButton from '../../components/home/course-section/ViewAllButton';
import GET_ALL_TAGS_AND_FILTERS from '../../gql/queries/get-all-tags-and-filters.gql';
import { useFirebase } from '../../contexts/ssr-firebase-context';
import { useMiscellaneousData } from '../../contexts/ssr-miscellaneous-context';
import DailySubjectiveHome from '../../components/daily-subjective-test/daily-subjective-home';
import FeatureList from '../../components/feature-list';
import GET_ALL_COURSE_TAGS from '../../gql/queries/get-all-courses-tags.gql';
import GET_ALL_COURSE_CENTERS from '../../gql/queries/get-all-courses-centers.gql';

// import { initializeApollo } from '../../../apollo-ssr';
// eslint-disable-next-line react/prop-types
function HomeTestSeries({ items, organizationId }) {
  // eslint-disable-next-line no-unused-vars
  const [type, setType] = useState('testseries');
  const {
    data: allFilterData,
    loading,
  } = useQuery(GET_ALL_TAGS_AND_FILTERS, {
    variables: { getOrganizationByIdId: organizationId, type },
  });

  const [onlineTagSelected, setOnlineTagSelectd] = useState();
  // const handleCourseTag = (tagId) => {
  //   setOnlineTagSelectd(tagId);
  // };
  if (loading) return <div>Loading...</div>;
  return (
    <section className="pt-[34px] lg:pt-[52px]">

      <div className="flex justify-between mb-[18px] lg:mb-7 items-center pr-5 lg:pr-0">
        <h2 className="xl:text-2xl text-lg font-semibold">
          {items?.heading}
        </h2>
      </div>
      <div className="flex justify-between items-center mb-4">
        <div className="w-full lg:w-[90%]">
          <CourseTags homePadding="p-0" pageType="mocktest" tagsList={allFilterData?.getOrganizationById?.tags || []} queryPareamsTag={onlineTagSelected} changeCourseTag={setOnlineTagSelectd} />
        </div>
        <div className="mb-6 lg:mb-0">
          <ViewAllButton
            pageUrl="/all-courses"
            queryString={`?scope=${'testseries'}&tag=${onlineTagSelected || 'all'}`}
            typeButton={2}
          />
        </div>
      </div>
      <TestSeriesCard pageType="Home" remoteConfigData={items} queryPareams setSelectedTag={onlineTagSelected} />
      <div className="lg:hidden mt-8">
        <ViewAllButton
          pageUrl="/all-courses"
          queryString={`?scope=${'testseries'}&tag=${onlineTagSelected || 'all'}`}
        />
      </div>
    </section>
  );
}

function Home({
  initialOnlineCoursesData, initialOfflineCoursesData, hostname, initialTagsData, initialCentersData,
}) {
  // console.log('initialOnlineCoursesData', initialOnlineCoursesData);
  // console.log('allprops', user);
  const { user } = useUser();
  const { miscellaneousData } = useMiscellaneousData();
  const { getConfigValue } = useFirebase();
  const isTestSeriesLive = getConfigValue('isTestSeriesLive');
  let webHomeData;
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'UAT') {
    webHomeData = getConfigValue('web_home_uat') || [];
  }
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'BETA') {
    webHomeData = getConfigValue('web_home_beta') || [];
  }
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PROD' || process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PREPROD') {
    webHomeData = getConfigValue('web_home_prod') || [];
  }
  // const webHomeMenus = JSON.parse(getConfigValue('webHomeMenus'));

  const { title } = getMetadata('Home', hostname); // metadataTitle

  // testsseries check
  const [testSeriesCheck, setTestseriesCheck] = useState();
  useEffect(() => {
    if (['PROD', 'PREPROD'].includes(process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV)) {
      setTestseriesCheck(isTestSeriesLive);
    } else {
      setTestseriesCheck(true);
    }
  }, [isTestSeriesLive]);
  // rendering for uat, beta, prod

  // Add safety check for webHomeData
  if (!webHomeData || !webHomeData.data) {
    return null; // or return a loading component
  }

  const renderItmes = webHomeData.data.map((items) => items);
  // console.log('renderItmes', renderItmes);
  const centerDefaultSelect = webHomeData?.defaultCenterSelect;

  const currentOrg = getOrganizationPropertiesByHost(miscellaneousData?.hostname);
  const organizationId = currentOrg?.orgId || '2410f924-6cc4-4e88-b490-ffd3bbc40d03';
  // console.log('organizationId', webHomeData);

  const [fetchOnlineData, {
    data: onlineQueryData, loading: onlineLoading,
    networkStatus: onlineNetworkStatus,
  }] = useLazyQuery(GET_COURSES_BY_TAGS, {
    // skip: initialOnlineCoursesData,
    // ssr: true,
    variables: {
      orgId: organizationId,
      filters: [
        {
          key: 'centreId',
          value: '',
        },
        {
          key: 'tagId',
          value: '',
        },
        {
          key: 'mode',
          value: 'Online',
        },
      ],
    },
    // fetchPolicy: 'cache-first',
  });
  const onlineData = onlineQueryData ?? initialOnlineCoursesData;

  // console.log('jjsjsd', onlineData);
  const [fetchOfflineData, {
    data: offlineQueryData, loading: offlineLoading, networkStatus: offlineNetworkStatus,
  }] = useLazyQuery(GET_COURSES_BY_TAGS, {

    // ssr: true,
    // skip: initialOfflineCoursesData,
    variables: {
      orgId: organizationId,
      filters: [
        {
          key: 'centreId',
          value: centerDefaultSelect,
        },
        {
          key: 'tagId',
          value: '',
        },
        {
          key: 'mode',
          value: 'Offline', // TODO: will be changed to offline once the BE is updated
        },
      ],
    },
    // fetchPolicy: 'cache-first',
  });
  const offlineData = offlineQueryData ?? initialOfflineCoursesData;

  const {
    data: tagQueryData,
  } = useQuery(GET_ALL_COURSE_TAGS, {
    variables: {
      getOrganizationByIdId: organizationId,
      orgId: organizationId,
      page: 'home',
    },
    notifyOnNetworkStatusChange: true,
    skip: !!initialTagsData,
  });

  const {
    data: centerQueryData,
  } = useQuery(GET_ALL_COURSE_CENTERS, {
    variables: {
      getOrganizationByIdId: organizationId,
    },
    notifyOnNetworkStatusChange: true,
    skip: !!initialCentersData,
  });

  useEffect(() => {
    if (!initialOnlineCoursesData) {
      fetchOnlineData();
    }
    if (!initialOfflineCoursesData) {
      fetchOfflineData();
    }
  }, []);

  // eslint-disable-next-line consistent-return
  const renderHomeComponents = (type, items) => {
    // console.log('type....', items);
    if (type === 'banner') {
      return <HomeTopSlider />;
    }
    if (type === 'offlineCourses') {
      return (
        <OfflineCourses
          initialCentersData={initialCentersData || centerQueryData}
          centerSelected={centerDefaultSelect}
          initialTagsData={initialTagsData || tagQueryData}
          offlineData={offlineData}
          heading={items.heading}
          order={items.order}
          refetchOfflineCourses={fetchOfflineData}
          offlineNetworkStatus={offlineNetworkStatus}
          offlineLoading={offlineLoading}
        />
      );
    }
    if (type === 'onlineCourses') {
      return (
        <OnlineCourses
          centerSelected={centerDefaultSelect}
          initialTagsData={initialTagsData || tagQueryData}
          onlineData={onlineData}
          heading={items.heading}
          order={items.order}
          refetchOnlineCourses={fetchOnlineData}
          onlineNetworkStatus={onlineNetworkStatus}
          onlineLoading={onlineLoading}
        />
      );
    }
    if (type === 'slotBookingSection' && user?.id && !user?.paidAccess?.isPaid) {
      return <SlotBooking remoteConfigData={items} accountId={user?.id} />;
    }
    if (type === 'featureList') {
      return <FeatureList item={items} id={user?.id} />;
    }
    if (type === 'quickLinks') {
      return <QuickLinksList remoteConfigData={items} />;
    }
    if (type === 'mockTests' && testSeriesCheck) {
      return (
        <HomeTestSeries
          organizationId={organizationId}
          items={items}
          onlineData={onlineData}
        />
      );
    }
    if (type === 'DailySubjectiveTest') {
      return (
        <DailySubjectiveHome pageType="Home" listLimit={items?.limit} contentHeading={items?.heading} />
      );
    }
  };
  const dynamicComponent = renderItmes.map((items, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={`${items.type}-${index}`}>
      {renderHomeComponents(items.type, items)}
    </React.Fragment>
  ));

  return (
    <>
      <MetaHead title={title} hostname={hostname} />

      <div className="pl-5 lg:pl-0">
        {dynamicComponent}
      </div>
    </>
  );
}
export default Home;
